import { openTimeByGroup } from '@/store/config';
import { usePairs } from '@/store/pairs';
import { checkIsClosed } from '@/utils/time';
import { useMemo } from 'react';
import { useShallow } from 'zustand/shallow';

export function useCheckClosePair(pairIndex: number) {
    const pairs = usePairs(useShallow((state) => state.data));

    const pair = useMemo(() => {
        return pairs.find((item) => item.pairIndex === pairIndex);
    }, [pairIndex, pairs]);

    const isClose = useMemo(() => {
        if (!pair?.groupName) {
            return false;
        }

        if (pair?.isAlwaysOpen) {
            return false;
        }

        if (!openTimeByGroup[pair?.groupName]) {
            return false;
        }

        return checkIsClosed(
            pair?.groupName,
            openTimeByGroup?.[pair?.groupName]
        );
    }, [pair?.groupName, pair?.isAlwaysOpen]);
    return { isClose };
}
